import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex items-center mb-4" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = {
    key: 0,
    class: "lg:flex"
};
const _hoisted_5 = { class: "lg:w-1/2 lg:mr-2" };
const _hoisted_6 = { class: "w-full h-48" };
const _hoisted_7 = { class: "text-slate-600" };
const _hoisted_8 = { class: "p-2 text-right" };
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "p-2 text-right" };
const _hoisted_11 = { class: "p-2 text-right" };
const _hoisted_12 = { class: "p-2 text-right" };
const _hoisted_13 = { class: "p-2 text-right" };
const _hoisted_14 = {
    class: "w-full",
    role: "presentation"
};
const _hoisted_15 = { class: "p-2 text-right text-slate-600 font-medium" };
const _hoisted_16 = { class: "lg:w-1/2 lg:ml-2" };
const _hoisted_17 = { class: "w-full h-48" };
const _hoisted_18 = { class: "text-slate-600" };
const _hoisted_19 = { class: "p-2 text-right" };
const _hoisted_20 = { class: "p-2 text-right" };
const _hoisted_21 = { class: "p-2 text-right" };
const _hoisted_22 = { class: "p-2 text-right" };
const _hoisted_23 = { class: "p-2 text-right" };
const _hoisted_24 = { class: "p-2 text-right" };
const _hoisted_25 = { class: "p-2 text-right" };
const _hoisted_26 = { class: "flex items-center mb-4" };
const _hoisted_27 = {
    key: 0,
    class: "flex"
};
const _hoisted_28 = { class: "hidden lg:flex items-center mr-2" };
const _hoisted_29 = ["value"];
const _hoisted_30 = {
    key: 2,
    id: "campaign-code-orders",
    class: "admin-table"
};
const _hoisted_31 = { class: "colored-row" };
const _hoisted_32 = { class: "w-16" };
const _hoisted_33 = ["aria-labelledby"];
const _hoisted_34 = { class: "font-medium" };
const _hoisted_35 = { class: "text-slate-500" };
const _hoisted_36 = { class: "text-center" };
const _hoisted_37 = { class: "text-center font-semibold" };
const _hoisted_38 = { class: "font-medium" };
const _hoisted_39 = ["href"];
const _hoisted_40 = { class: "sr-only" };
const _hoisted_41 = { class: "my-loading" };
const _hoisted_42 = { class: "no-results panel p-10 mt-4" };
const _hoisted_43 = { class: "text-center mt-4 text-sm text-slate-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            (!_ctx.campaign.isLoaded())
                ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Mange Campaign"))
                : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.campaign.data.name), 1)),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.campaign.navigation.goBack && _ctx.campaign.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back"),
                (_ctx.campaign.isLoaded())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'admin.campaign.product.manage', params: { account: _ctx.campaign.data.account, slug: _ctx.campaign.data.slug } },
                        class: "flex btn ml-2 items-center"
                    }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Manage Products ", -1)
                            ]))]),
                        _: 1
                    }, 8, ["to"]))
                    : _createCommentVNode("", true),
                (_ctx.campaign.isLoaded() && _ctx.permissions.isProgrammeManager())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: { name: 'admin.campaign.edit', params: { account: _ctx.campaign.data.account, slug: _ctx.campaign.data.slug } },
                        class: "flex btn ml-2 items-center"
                    }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" Edit Campaign ", -1)
                            ]))]),
                        _: 1
                    }, 8, ["to"]))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.campaign.isLoaded())
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("section", _hoisted_5, [
                    _createElementVNode("table", _hoisted_6, [
                        _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-800",
                                    colspan: "2"
                                }, "Campaign Details")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_7, [
                            _createElementVNode("tr", null, [
                                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Name", -1)),
                                _createElementVNode("td", _hoisted_8, [
                                    _createTextVNode(_toDisplayString(_ctx.campaign.data.name) + " <", 1),
                                    _createElementVNode("a", {
                                        href: _ctx.campaign.data.endpoint,
                                        class: "text-brand-600 font-medium",
                                        target: "_blank"
                                    }, _toDisplayString(_ctx.campaign.data.slug), 9, _hoisted_9),
                                    _cache[5] || (_cache[5] = _createTextVNode(">", -1))
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Start Date", -1)),
                                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.f.formatDate(_ctx.campaign.data.start_date)) + " (" + _toDisplayString(_ctx.f.getTimeZone()) + ")", 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "End Date", -1)),
                                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.campaign.data.end_date ? _ctx.f.formatDate(_ctx.campaign.data.end_date) + ' (' + _ctx.f.getTimeZone() + ')' : 'No End Date'), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Status", -1)),
                                _createElementVNode("td", _hoisted_12, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["status-box", _ctx.f.statusBox(_ctx.campaign.data.status.campaign_status)])
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.campaign.data.status.campaign_status), 1),
                                        _cache[9] || (_cache[9] = _createElementVNode("span", null, [
                                            _createElementVNode("span"),
                                            _createElementVNode("span")
                                        ], -1))
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Currency", -1)),
                                _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.campaign.data.currency), 1)
                            ])
                        ])
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "my-2 border-slate-400" }, null, -1)),
                    _createElementVNode("table", _hoisted_14, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "p-2 text-left text-slate-600" }, "Created", -1)),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.f.formatDate(_ctx.campaign.data.created_at)) + " by " + _toDisplayString(_ctx.campaign.data.user_name), 1)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_16, [
                    _createElementVNode("table", _hoisted_17, [
                        _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-800",
                                    colspan: "2"
                                }, "Metrics")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_18, [
                            _createElementVNode("tr", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Expires In", -1)),
                                _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.campaign.metrics.time_remaining), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Total Codes", -1)),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.campaign.metrics.total_codes), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Redeemed Codes", -1)),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.campaign.metrics.redeemed_codes), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[18] || (_cache[18] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Available Codes", -1)),
                                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.campaign.metrics.unredeemed_codes), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Total Value", -1)),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.f.formatCurrency(_ctx.campaign.data.currency, _ctx.campaign.metrics.total_value / 100)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[20] || (_cache[20] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Remaining Value", -1)),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.f.formatCurrency(_ctx.campaign.data.currency, _ctx.campaign.metrics.remaining_value / 100)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Redeemed Value", -1)),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.f.formatCurrency(_ctx.campaign.data.currency, _ctx.campaign.metrics.redeemed_value / 100)), 1)
                            ])
                        ])
                    ])
                ])
            ]))
            : (_openBlock(), _createBlock(_component_Loading, {
                key: 1,
                message: "Loading Campaign"
            })),
        _createElementVNode("div", _hoisted_26, [
            _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "flex-1 font-medium text-xl" }, "Campaign Codes", -1)),
            (_ctx.campaign.isLoaded())
                ? (_openBlock(), _createElementBlock("nav", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", {
                            for: "account_id",
                            class: "form-label-style w-48 text-right mr-2"
                        }, "Export Format", -1)),
                        _withDirectives(_createElementVNode("select", {
                            name: "account_id",
                            id: "account_id",
                            class: "form-input-style",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.codes.export_format) = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event) => (_ctx.codes.updateDownloadFormat())),
                            autocomplete: "off"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes.exportFormats, (method) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    value: method.value
                                }, _toDisplayString(method.name), 9, _hoisted_29));
                            }), 256))
                        ], 544), [
                            [_vModelSelect, _ctx.codes.export_format]
                        ])
                    ]),
                    (_ctx.campaign.isLoaded() && _ctx.permissions.isProgrammeManager() && !_ctx.campaign.data.status.campaign_ended)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'admin.campaign.code.create', params: { account: _ctx.campaign.data.account, slug: _ctx.campaign.data.slug } },
                            class: "flex btn ml-2 items-center"
                        }, {
                            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                    _createTextVNode(" Order Codes ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["to"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true)
        ]),
        (_ctx.codes.hasResults())
            ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Order ID"),
                                        _createElementVNode("th", {
                                            scope: "col",
                                            class: "text-center"
                                        }, "Status"),
                                        _createElementVNode("th", {
                                            scope: "col",
                                            class: "text-center"
                                        }, "Quantity"),
                                        _createElementVNode("th", { scope: "col" }, " ")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes.getData(), (code_order) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                            _createElementVNode("td", _hoisted_32, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-10 w-10 text-slate-400 mx-auto",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    role: "img",
                                                    focusable: "false",
                                                    "aria-labelledby": code_order.id
                                                }, [...(_cache[26] || (_cache[26] = [
                                                        _createElementVNode("title", null, "Order", -1),
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                                                        }, null, -1)
                                                    ]))], 8, _hoisted_33))
                                            ]),
                                            _createElementVNode("td", _hoisted_34, [
                                                _createVNode(_component_router_link, {
                                                    class: "block",
                                                    to: { name: 'admin.campaign.code.show', params: { account: _ctx.codes.account, slug: _ctx.codes.slug, order: code_order.id } },
                                                    id: code_order.id
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(code_order.id), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to", "id"]),
                                                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.f.formatDateShort(code_order.created_at)), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_36, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["status-box", {
                                                            'status-processing': code_order.status === 'processing',
                                                            'status-complete': code_order.status === 'complete',
                                                            'status-cancelled': code_order.status === 'cancelled',
                                                        }])
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(code_order.status), 1),
                                                    _cache[27] || (_cache[27] = _createElementVNode("span", null, [
                                                        _createElementVNode("span"),
                                                        _createElementVNode("span")
                                                    ], -1))
                                                ], 2)
                                            ]),
                                            _createElementVNode("td", _hoisted_37, _toDisplayString(code_order.code_order_quantity), 1),
                                            _createElementVNode("td", _hoisted_38, [
                                                (code_order.status === 'complete')
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: `/admin/download/code/${code_order.id}?format=${_ctx.codes.export_format}`,
                                                        target: "_blank",
                                                        class: "dark mr-2"
                                                    }, " Download Codes ", 8, _hoisted_39))
                                                    : (_openBlock(), _createBlock(_component_router_link, {
                                                        key: 1,
                                                        class: "btn",
                                                        to: { name: 'admin.campaign.code.show', params: { account: _ctx.codes.account, slug: _ctx.codes.slug, order: code_order.id } }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _cache[28] || (_cache[28] = _createTextVNode(" Order Details", -1)),
                                                            _createElementVNode("span", _hoisted_40, ", " + _toDisplayString(code_order.id), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"]))
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_Loading, { message: "Loading Campaign Code Orders" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#campaign-code-orders",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-20 w-20 mx-auto",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                            })
                        ])
                    ], -1)),
                    _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Campaign Code Orders Available", -1)),
                    _createElementVNode("p", _hoisted_43, [
                        _cache[32] || (_cache[32] = _createTextVNode(" We could not find any code orders for this campaign, ", -1)),
                        _createVNode(_component_router_link, {
                            to: { name: 'admin.campaign.code.create', params: { account: _ctx.campaign.data.account, slug: _ctx.campaign.data.slug } }
                        }, {
                            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                    _createTextVNode("create order", -1)
                                ]))]),
                            _: 1
                        }, 8, ["to"]),
                        _cache[33] || (_cache[33] = _createTextVNode(". ", -1))
                    ])
                ])
            ]),
            error: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ]));
}
